class DrvProducts extends HTMLElement {
  connectedCallback() {
    this.tagsWrap = this.querySelector('.drv-products__tags');
    this.groupsWrap = this.querySelector('.drv-products__groups');
    this.barsWrap = this.querySelector('.drv-products__bars');
    const staging = this.querySelector('.drv-products__staging');
    if (!staging) return;

    this.tags = [];
    this.groups = [];
    [...staging.querySelectorAll('[data-drv-tag]')].forEach((tag) => {
      this.tagsWrap.appendChild(tag);
      this.tags.push(tag);
    });
    [...staging.querySelectorAll('[data-drv-group]')].forEach((group) => {
      this.groupsWrap.appendChild(group);
      this.groups.push(group);
    });
    staging.remove();
    if (!this.groups.length) return;

    this.tags.forEach((tag, i) => tag.addEventListener('click', () => this.activate(i)));
    this.querySelector('[data-prev]')?.addEventListener('click', () => this.slide(-1));
    this.querySelector('[data-next]')?.addEventListener('click', () => this.slide(1));
    let frame = 0;
    this.groupsWrap.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => this.update());
    }, { passive: true });
    window.addEventListener('resize', () => {
      this.place();
      this.update();
    });
    if (window.DrvDrag) {
      window.DrvDrag.scroll(this.groupsWrap, () => this.step);
      window.DrvDrag.scroll(this.tagsWrap);
    }

    this.place();
    this.activate(0);
  }

  place() {
    const btn = this.querySelector('.drv-products__btn');
    if (!btn) return;
    if (window.matchMedia('(min-width: 990px)').matches) {
      this.querySelector('.drv-products__left').appendChild(btn);
    } else {
      this.appendChild(btn);
    }
  }

  activate(i) {
    this.active = i;
    this.tags.forEach((t, j) => t.classList.toggle('is-active', j === i));
    this.groups.forEach((g, j) => g.classList.toggle('is-active', j === i));
    this.groupsWrap.scrollLeft = 0;
    this.buildBars();
    this.update();
  }

  get step() {
    const track = this.track;
    const card = track?.children[0];
    if (!card) return 0;
    return card.offsetWidth + (parseFloat(getComputedStyle(track).gap) || 0);
  }

  get pos() {
    const step = this.step;
    if (!step) return 0;
    const wrap = this.groupsWrap;
    if (wrap.scrollLeft >= wrap.scrollWidth - wrap.clientWidth - 2) return this.maxPos;
    return Math.min(this.maxPos, Math.round(wrap.scrollLeft / step));
  }

  goTo(i) {
    const left = Math.max(0, Math.min(this.maxPos, i)) * this.step;
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.groupsWrap.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
  }

  get track() {
    return this.groups[this.active].querySelector('[data-drv-track]');
  }

  get maxPos() {
    const track = this.track;
    const cards = track.children.length;
    if (!cards) return 0;
    const viewport = this.groupsWrap.clientWidth;
    const card = track.children[0];
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    const step = card.offsetWidth + gap;
    const visible = Math.max(1, Math.floor((viewport + gap) / step));
    return Math.max(0, cards - visible);
  }

  buildBars() {
    this.barsWrap.textContent = '';
    const stops = this.maxPos + 1;
    this.bars = [];
    if (stops <= 1) return;
    for (let i = 0; i < stops; i++) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'drv-products__bar';
      if (this.dataset.barLabel) b.setAttribute('aria-label', this.dataset.barLabel.replace('[index]', i + 1));
      b.addEventListener('click', () => this.goTo(i));
      this.barsWrap.appendChild(b);
      this.bars.push(b);
    }
  }

  slide(dir) {
    this.goTo(this.pos + dir);
  }

  update() {
    const track = this.track;
    if (!track || !track.children.length) return;
    const max = this.maxPos;
    if ((this.bars?.length || 0) !== (max > 0 ? max + 1 : 0)) this.buildBars();
    const pos = this.pos;
    this.bars.forEach((b, j) => b.classList.toggle('is-active', j === pos));
    const wrap = this.groupsWrap;
    const prev = this.querySelector('[data-prev]');
    const next = this.querySelector('[data-next]');
    if (prev) prev.disabled = wrap.scrollLeft <= 2;
    if (next) next.disabled = wrap.scrollLeft >= wrap.scrollWidth - wrap.clientWidth - 2;
    this.querySelector('.drv-products__arrows')?.classList.toggle('is-idle', max === 0);
  }
}

if (!customElements.get('drv-products')) {
  customElements.define('drv-products', DrvProducts);
}
